import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import '../../entity-forms.css';

export default function Personnel() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]         = useState([]);
  const [isload, setisload]     = useState(true);
  const [teams, setteams]       = useState([]);
  const [roles, setRoles]       = useState([]);
  const [search, setSearch]     = useState('');

  const initForm = { user: sessionStorage.getItem('userid'), teams: [], access: '0' };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); loadTeams(); loadRoles(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/personnel/getPersonnels`);
      if (res.data.success) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadTeams = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getTeams`);
      if (res.data.data) setteams(res.data.data);
    } catch {}
  };

  const loadRoles = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/configure/getRoles`);
      if (res.data.success) setRoles(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => {
    setForm({ ...row, teams: Array.isArray(row.teams) ? row.teams : (row.teams ? [row.teams] : []) });
    setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true);
  };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  /* teams multi-select toggle */
  const toggleTeam = (teamId) => {
    setForm(p => {
      const current = p.teams || [];
      return { ...p, teams: current.includes(teamId) ? current.filter(x => x !== teamId) : [...current, teamId] };
    });
  };

  /* access=1 → all teams */
  const handleAccessChange = (val) => {
    if (val === '1') {
      setForm(p => ({ ...p, access: '1', teams: teams.map(t => t.teamId) }));
    } else {
      setForm(p => ({ ...p, access: '0', teams: [] }));
    }
  };

  const validate = () => {
    if (!form.personnel_name || !form.email || !form.phone || !form.role || !form.teams?.length || !form.access) {
      setMsg('Please fill all required fields (*)'); return false;
    }
    setMsg(''); return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const payload = {
        personnel_name: form.personnel_name,
        phone:          form.phone,
        email:          form.email,
        password:       form.password,
        teams:          form.teams,
        role:           form.role,
        access:         form.access,
        updated_by:     2,
      };
      if (isEdit) payload.personnel_id = form.personnel_id;
      const url = isEdit
        ? `${API_URL}shypvdriverapp/personnel/updatePersonnel`
        : `${API_URL}shypvdriverapp/personnel/createPersonnel`;
      const res = await axios({ method: 'post', url, data: payload, headers: { 'Content-Type': 'application/json' } });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg(res.data.errors?.[0]?.errorMessage || 'Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} personnel?`)) return;
    try {
      const res = await axios.delete(`${API_URL}shypvdriverapp/personnel/deletePersonnel`, {
        headers: { 'Content-Type': 'application/json' },
        data: { personnel_id: selectedIds },
      });
      if (res.data.success) { setSelectedIds([]); loadList(); }
      else setErrMsg('Delete failed');
    } catch { setErrMsg('Error deleting personnel'); }
  };

  const toggleSelect = (id, row) => {
    setSelectedIds(prev => {
      if (prev.includes(id)) { const next = prev.filter(x => x !== id); if (!next.length) setForm(initForm); return next; }
      setForm({ ...row, teams: Array.isArray(row.teams) ? row.teams : (row.teams ? [row.teams] : []) });
      return [...prev, id];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.personnel_name?.toLowerCase().includes(search.toLowerCase()) ||
    r.email?.toLowerCase().includes(search.toLowerCase()) ||
    r.phone?.includes(search)
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search personnel…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Personnel</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="personnel.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.personnel_id) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['ID','Name','Phone','Email','Role','Access','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={8} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading personnel…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No personnel found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.personnel_id);
              return (
                <tr key={row.personnel_id} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.personnel_id, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.personnel_id}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.personnel_name}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.phone}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.email}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.role}</td>
                  <td className="em-td">
                    <span className={`em-badge ${row.access==='1'?'em-badge-blue':'em-badge-grey'}`}>
                      {row.access==='1'?'All Teams':'Selected'}
                    </span>
                  </td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} personnel
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-id-badge" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Personnel' : 'Add New Personnel'}</p>
                    <p className="em-drawer-sub">{isEdit ? `ID: ${form.personnel_id}` : 'Fill in the personnel details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Personnel Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.personnel_name||''} placeholder="Full name"
                    onChange={e => setForm(p => ({ ...p, personnel_name: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Phone<span className="em-req">*</span></label>
                  <input className="em-field" value={form.phone||''} placeholder="+971 50 000 0000"
                    onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Email<span className="em-req">*</span></label>
                  <input className="em-field" type="email" value={form.email||''} placeholder="email@example.com"
                    onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Password{!isEdit && <span className="em-req">*</span>}</label>
                  <input className="em-field" type="password" value={form.password||''} placeholder={isEdit ? 'Leave blank to keep current' : 'Set password'}
                    onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Role<span className="em-req">*</span></label>
                  <select className="em-field" value={form.role||''} onChange={e => setForm(p => ({ ...p, role: e.target.value }))}>
                    <option value="">— Select role —</option>
                    {roles.map(r => <option key={r.roleId||r.id||r.role} value={r.roleName||r.role}>{r.roleName||r.role}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">All Team Access<span className="em-req">*</span></label>
                  <select className="em-field" value={form.access||'0'} onChange={e => handleAccessChange(e.target.value)}>
                    <option value="0">No — Selected Teams</option>
                    <option value="1">Yes — All Teams</option>
                  </select>
                </div>
              </div>

              {/* Teams multi-select */}
              <div className="em-form-row">
                <label className="em-label">Teams<span className="em-req">*</span></label>
                <div style={{ border:'1.5px solid #e2e8f0', borderRadius:10, padding:'8px 10px', maxHeight:140, overflowY:'auto', background:form.access==='1'?'#f8fafc':'#fff' }}>
                  {teams.length === 0 && <span style={{ color:'#94a3b8', fontSize:12 }}>Loading teams…</span>}
                  {teams.map(t => (
                    <label key={t.teamId} style={{ display:'flex', alignItems:'center', gap:8, padding:'4px 2px', cursor:'pointer', fontSize:13, color:'#334155' }}>
                      <input type="checkbox"
                        checked={(form.teams||[]).includes(t.teamId)}
                        onChange={() => toggleTeam(t.teamId)}
                        disabled={form.access==='1'} />
                      {t.teamName}
                    </label>
                  ))}
                </div>
                {form.access==='1' && <p style={{ fontSize:11, color:'#3b82f6', marginTop:4 }}>All teams selected automatically</p>}
              </div>

              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Personnel':'Save Personnel'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
